"use client";
import React, { createContext, useContext, useState } from "react";

export type GlobalCtxProps = {
  currentPlayingVideo: string | null;
  setCurrentPlayingVideo: (d: string | null) => void;
};

export const GlobalContext = createContext<GlobalCtxProps>(
  {} as GlobalCtxProps,
);

export const useGlobalCtx = () => useContext(GlobalContext);

export function GlobalContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState<string | null>(
    null,
  );

  return (
    <GlobalContext.Provider
      value={{
        currentPlayingVideo,
        setCurrentPlayingVideo,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}
